module.exports = __webpack_public_path__ + "static/img/site-logo.c321d42b.png";